(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yc-product-card"] && !Shopify.designMode) return;
  try {
    class RecCard extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('[data-rc-variants]').textContent); }
      catch (e) { this.variants = []; }
      this.idInput = this.querySelector('input[name="id"]');
      const wrap = this.querySelector('[data-rc-atc-wrap]');
      this.atcDefault = (wrap && wrap.dataset.default) || 'Add to Cart';
      this.soldOut = (wrap && wrap.dataset.soldout) || 'Sold out';
      this.querySelectorAll('[data-rc-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const g = btn.closest('[data-rc-group]');
          g.querySelectorAll('[data-rc-value]').forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this.update();
        });
      });

      // add-to-cart loading spinner until the cart line update resolves
      const atcBtn = this.querySelector('.rc-atc');
      if (atcBtn) {
        // Match the Collection tabs behaviour: skip Horizon's fly-to-cart
        // animation so the cart drawer opens immediately on click (~20ms)
        // instead of ~1.6s later (which left the spinner visibly hanging).
        const atcComp = this.querySelector('add-to-cart-component');
        if (atcComp) atcComp.dataset.addToCartAnimation = 'false';
        const setLoading = (on) => {
          atcBtn.classList.toggle('is-loading', on);
          if (on) {
            clearTimeout(this._atcTimer);
            this._atcTimer = setTimeout(() => atcBtn.classList.remove('is-loading'), 8000);
          } else {
            clearTimeout(this._atcTimer);
          }
        };
        atcBtn.addEventListener('click', () => { if (!atcBtn.disabled) setLoading(true); });
        this.addEventListener('shopify:cart:lines-update', (e) => {
          if (e.action && e.action !== 'add') return;
          const done = () => setLoading(false);
          if (e.promise && typeof e.promise.finally === 'function') e.promise.finally(done);
          else done();
        });
      }

      this.update();
    }
    update() {
      const groups = Array.from(this.querySelectorAll('[data-rc-group]'));
      if (!groups.length) return;
      const sel = groups.map((g) => { const s = g.querySelector('[data-rc-value].is-selected'); return s ? s.dataset.value : null; });
      groups.forEach((g, gi) => {
        const btns = Array.from(g.querySelectorAll('[data-rc-value]'));
        const earlier = (vr) => { for (let j = 0; j < gi; j++) { if (sel[j] != null && vr.options[j] !== sel[j]) return false; } return true; };
        btns.forEach((btn) => {
          const v = btn.dataset.value;
          const exists = this.variants.some((vr) => vr.options[gi] === v && earlier(vr));
          const inStock = this.variants.some((vr) => vr.options[gi] === v && vr.available && earlier(vr));
          btn.classList.toggle('is-hidden', !exists);
          btn.classList.toggle('is-soldout', exists && !inStock);
        });
        let selBtn = btns.find((b) => b.dataset.value === sel[gi] && !b.classList.contains('is-hidden'));
        if (!selBtn) {
          selBtn = btns.find((b) => !b.classList.contains('is-hidden') && !b.classList.contains('is-soldout')) || btns.find((b) => !b.classList.contains('is-hidden'));
          btns.forEach((b) => b.classList.remove('is-selected'));
          if (selBtn) { selBtn.classList.add('is-selected'); sel[gi] = selBtn.dataset.value; } else { sel[gi] = null; }
        }
      });
      const variant = sel.every((s) => s != null) ? this.variants.find((v) => v.options.length === sel.length && v.options.every((o, i) => o === sel[i])) : null;
      const priceEl = this.querySelector('[data-rc-price]');
      const compEl = this.querySelector('[data-rc-compare]');
      const btn = this.querySelector('.rc-atc');
      const txt = btn && (btn.querySelector('.add-to-cart-text__content span span span') || btn.querySelector('.add-to-cart-text__content'));
      if (!variant) { if (btn) { btn.disabled = true; if (txt) txt.textContent = this.soldOut; } return; }
      if (this.idInput) this.idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (compEl) { if (variant.compare) { compEl.textContent = variant.compare; compEl.hidden = false; } else { compEl.hidden = true; } }
      if (btn) { btn.disabled = !variant.available; if (txt) txt.textContent = variant.available ? this.atcDefault : this.soldOut; }
    }
  }
  if (!customElements.get('rec-card')) customElements.define('rec-card', RecCard);

  // While actively scrolling, add .yc-scrolling to <html> so the card hover-lift
  // is suppressed (see the CSS above). Bound once, capture phase so it also
  // catches Horizon's real scroll container (.page-wrapper), whose scroll events
  // don't bubble to window.
  if (!window.__ycScrollHoverBound) {
    window.__ycScrollHoverBound = true;
    const root = document.documentElement;
    let st;
    const onScroll = () => {
      root.classList.add('yc-scrolling');
      clearTimeout(st);
      st = setTimeout(() => root.classList.remove('yc-scrolling'), 120);
    };
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  }
  } catch(e) { console.error(e); }
})();

})();
